import iconCourses from '../../../assets/icons/courses'
import iconTransactions from '../../../assets/icons/transactions'
import iconSubscription from '../../../assets/icons/subscription'
import iconDashboard from '../../../assets/icons/dashboard'
import iconSettings from '../../../assets/icons/settings'

const DefaultStore = {
    showMenu: false,
    activeItem: 0,
    items: [{
        text: "Dashboard",
        icon: iconDashboard,
        permissions: [],
        subItems: []
    },
    {
        text: "My Wallet",
        url: "/payment/wallet",
        icon: iconCourses,
        permissions: []
    },
    {
        text: "Obligations",
        url: "/payment/obligations",
        icon: iconSubscription,
        permissions: []
    },
    {
        text: "Transactions",
        url: "/payment/transactions",
        icon: iconTransactions,
        permissions: [1, 8, 9]
    },
    {
        text: "Settings",
        url: "/settings/profile",
        icon: iconSettings,
        permissions: []
    }
    ]
}

export default DefaultStore